@media screen {
    .container {
        display: flex;
        justify-content: center;
        align-items: start;
        padding-top: 32px;
        box-sizing: border-box;
    }

    .profile {
        width: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        padding-top: 128px;
    }

    .profileContent {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
    }

    .schedulerPreview {
        width: 100%;
        max-width: 825px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

@media screen and (max-width: 1560px) {
    .container {
        flex-direction: column;
        align-items: center;
        gap: 16px;
        height: auto;
        padding-top: 32px;
    }

    .profile {
        width: 600px;
        flex-direction: row;
        gap: 32px;
        padding-top: 0;
    }

    .profileContent {
        align-items: flex-start;
    }
}

@media screen and (max-width: 775px) {
    .profile {
        width: 400px;
        flex-direction: column;
        gap: 8px;
    }

    .profileContent {
        align-items: center;
    }
}

@media screen and (max-width: 600px) {
    .profile {
        width: 100%;
        /* Match the padding of the scheduler preview */
        padding: 0 32px;
        box-sizing: border-box;
    }
}
